const FormHelpers = {
  // Helper function to normalize addresses for comparison
  normalizeAddressForComparison: (address) => {
    if (!address) return '';
    
    // Convert to lowercase for case-insensitive comparison
    let normalized = address.toLowerCase();
    
    // Common street type abbreviations with and without periods
    const abbreviations = {
      'avenue': 'ave',
      'ave.': 'ave',
      'ave': 'ave',
      
      'boulevard': 'blvd',
      'blvd.': 'blvd',
      'blvd': 'blvd',
      
      'circle': 'cir',
      'cir.': 'cir',
      'cir': 'cir',
      
      'court': 'ct',
      'ct.': 'ct',
      'ct': 'ct',
      
      'drive': 'dr',
      'dr.': 'dr',
      'dr': 'dr',
      
      'expressway': 'expy',
      'expy.': 'expy',
      'expy': 'expy',
      
      'extension': 'ext',
      'ext.': 'ext',
      'ext': 'ext',
      
      'freeway': 'fwy',
      'fwy.': 'fwy',
      'fwy': 'fwy',
      
      'highway': 'hwy',
      'hwy.': 'hwy',
      'hwy': 'hwy',
      
      'lane': 'ln',
      'ln.': 'ln',
      'ln': 'ln',

      'mount': 'mt',
      'mt.': 'mt',
      'mt': 'mt',
      
      'parkway': 'pkwy',
      'pkwy.': 'pkwy',
      'pkwy': 'pkwy',
      
      'place': 'pl',
      'pl.': 'pl',
      'pl': 'pl',
      
      'plaza': 'plz',
      'plz.': 'plz',
      'plz': 'plz',
      
      'road': 'rd',
      'rd.': 'rd',
      'rd': 'rd',
      
      'square': 'sq',
      'sq.': 'sq',
      'sq': 'sq',
      
      'street': 'st',
      'st.': 'st',
      'st': 'st',
      
      'terrace': 'ter',
      'ter.': 'ter',
      'ter': 'ter',
      
      'trail': 'trl',
      'trl.': 'trl',
      'trl': 'trl',
      
      'turnpike': 'tpke',
      'tpke.': 'tpke',
      'tpke': 'tpke',
      
      'way': 'way',
      'way.': 'way'
    };
    
    // First remove all periods to normalize abbreviations with dots
    normalized = normalized.replace(/\./g, '');
    
    // Replace full words with abbreviations
    Object.entries(abbreviations).forEach(([full, abbr]) => {
      // Match full word with word boundary
      const fullPattern = new RegExp(`\\b${full}\\b`, 'g');
      normalized = normalized.replace(fullPattern, abbr);
    });
    
    // Normalize directional abbreviations
    const directions = {
      'north': 'n',
      'n.': 'n',
      'n': 'n',
      
      'south': 's',
      's.': 's',
      's': 's',
      
      'east': 'e',
      'e.': 'e',
      'e': 'e',
      
      'west': 'w',
      'w.': 'w',
      'w': 'w',
      
      'northeast': 'ne',
      'ne.': 'ne',
      'ne': 'ne',
      
      'northwest': 'nw',
      'nw.': 'nw',
      'nw': 'nw',
      
      'southeast': 'se',
      'se.': 'se',
      'se': 'se',
      
      'southwest': 'sw',
      'sw.': 'sw',
      'sw': 'sw'
    };
    
    Object.entries(directions).forEach(([full, abbr]) => {
      const fullPattern = new RegExp(`\\b${full}\\b`, 'g');
      normalized = normalized.replace(fullPattern, abbr);
    });
    
    // Normalize apartment/unit designators
    normalized = normalized
      .replace(/\bapartment\b/g, 'apt')
      .replace(/\bapt\b/g, 'apt')
      .replace(/\bunit\b/g, 'unit')
      .replace(/\bsuite\b/g, 'ste')
      .replace(/\bste\b/g, 'ste')
      .replace(/\bbuilding\b/g, 'bldg')
      .replace(/\bbldg\b/g, 'bldg')
      .replace(/\#/g, 'unit')
      .replace(/\bfloor\b/g, 'fl')
      .replace(/\bfl\b/g, 'fl');
      
    // Remove common punctuation and normalize spaces
    normalized = normalized.replace(/[,;#]/g, '').replace(/\s+/g, ' ').trim();
    
    // Normalize ordinal numbers (1st, 2nd, 3rd, etc.)
    normalized = normalized
      .replace(/(\d+)(?:st|nd|rd|th)\b/g, '$1');
      
    // Normalize numbering formats (remove dashes and spaces in numbers)
    normalized = normalized
      .replace(/(\d+)\s*-\s*(\d+)/g, '$1$2');
      
    return normalized;
  },
  getStateProvinceCode: (spList, name) => {
    if(name) {
      let stateCode = spList.find((element) => element.Value === name);
      if(typeof stateCode !== 'undefined') {
        return stateCode.Key;
      } else {
        return '';
      }
    } else {
      return '';
    }
  },
  isValidForm: (errors, isTouched) => {
    return (
      Object.keys(errors).length === 0 && Object.keys(isTouched).length > 0
    );
  },
  getValues: (originalValues) => {
    let vals = {
      ...originalValues,
    };
    return vals;
  },
  scrollToTop: () => {
    const pageTop = document.getElementsByClassName("page");
    if(pageTop) {
      window.scrollTo({
        top: pageTop[0].offsetTop,
        behavior: "smooth",
      });
    }
  },
  handleMultilineKeyUp: (e) => {
    FormHelpers.forceMaxLength(e);
    if (e.keyCode == 17 || (e.keyCode == 65 && e.ctrlKey)) {
    }
    else {
        FormHelpers.fixMultiline(e);
    }
  },
  handleMultilineKeyDown: (e) => {
    if (e.keyCode != 8 && e.keyCode != 46 && e.keyCode != 17 && !e.ctrlKey) {
      FormHelpers.fixMultiline(e);
    }
  },
  handleMultilineUpdate: (e) => {
    FormHelpers.forceMaxLength(e);
    FormHelpers.fixMultiline(e);
  },
  forceMaxLength: (e) => {
    const maxLength = Number(e.target.getAttribute('datamax'));
    const inputLength = e.target.value.length-1;

    if (inputLength > maxLength) {
      e.target.value = e.target.value.substring(0, maxLength);
    }
  },
  fixMultiline: (e) => {
    var textArea = e.target;
    var maxRows = Number(e.target.getAttribute('rows'));
    var maxCols = Number(e.target.getAttribute('cols'));
    var myText = e.target.value;
    var lines = [];
    var cursorPosition = textArea.selectionStart;
    var validCodes = [8, 9, 37, 38, 39, 40, 46, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 110, 190];
    var max = e.target.getAttribute('rows');
    var current = document.activeElement;
    var count = 0;
    var currentLine = e.target.value.substr(0, e.target.selectionStart).split("\n").length;

    if (currentLine == maxRows && e.keyCode == 13) {
        e.preventDefault();
    }

    var cursorBefore = cursorPosition;
    if (myText.indexOf('\n') == -1) {
        lines[0] = myText;
    }
    else {
        lines = myText.split('\n');
    }

    var inp = String.fromCharCode(e.keyCode);

    if (inp != "" && inp != "") {
        if (currentLine == maxRows) {
            if (typeof lines[maxRows - 1] != "undefined" && lines[maxRows - 1].length >= maxCols) {
                e.preventDefault();
            }
        }
    }
    var linelength = lines.length;

    for (var i = 0; i < (lines.length); i++) {
        if (lines[i].length > maxCols) {
            var breakPoint = maxCols;
            for (var s = maxCols; s > 0; s--) {
                if (lines[i].charAt(s) == ' ') {
                    breakPoint = s;
                    var charsToSubtract = 0;
                    for (var t = 0; t < (linelength); t++) {
                        if (t + 1 < currentLine) {
                            charsToSubtract += lines[t].length;
                        }
                    }
                    if (i + 1 == currentLine && (cursorPosition - charsToSubtract) > breakPoint) {
                        cursorPosition++;
                    }
                    break;
                }
            }
            var newLine1 = lines[i].substr(0, breakPoint);
            var lettersToWrap = lines[i].substr(breakPoint, lines[i].length - 1);

            lines[i] = newLine1;
            var newStringForTheNextLine = "";
            if (typeof lines[i + 1] !== 'undefined') {

                newStringForTheNextLine = lettersToWrap + lines[i + 1];
                lines[i + 1] = newStringForTheNextLine;
            }
            else {
                newStringForTheNextLine = lettersToWrap;
                lines.push(String(newStringForTheNextLine));
            }

        }

    }

    if (lines.length > 1) {
        var finalString = "";
        for (var i = 0; i < (lines.length); i++) {
            if (i > 0 && i < maxRows) {
                finalString += "\n";
            }
            if (i < maxRows) {
                if (!textArea.classList.contains('customVerseInput')) {
                    finalString += FormHelpers.leftTrim(lines[i]);
                } else {
                    finalString += lines[i];
                }
            }
        }
        
        if (!textArea.classList.contains('customVerseInput')) {
            textArea.value = finalString;
        } else {
            textArea.value = finalString;
        }

        if(cursorBefore == cursorPosition) {
            textArea.selectionEnd = cursorPosition;
        } else {
            textArea.selectionEnd = (cursorPosition-1);
        }
 
    }
  },
  leftTrim: (str) => {
    return str.replace(/^\s+/, "");
  },
};

export default FormHelpers;
